module.exports = __webpack_public_path__ + "static/media/csea.fe5d7984.png";